import React, {Component} from "react";
import {NavItem, Nav} from "react-bootstrap";
import {connect} from "react-redux";
import NotificationContainer from "./Bell";
import logoutIcon from "assets/img/logout.svg";
import {adminUserActions} from "redux/actions/admin-user-action";
import Pusher from "pusher-js";
import {alertActions} from "redux/actions/alert-actions";
import userIcon from "../../../assets/img/user.svg";
import password from "../../../assets/img/lockIcon.svg";
import {Link} from "react-router-dom";

class HeaderLinksPage extends Component {
    constructor(props) {
        super(props);
        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : null;
        this.state = {
            message: null,
            user_role: user ? user.roles[0].name : ''
        };
    }

    componentDidMount() {
        Pusher.logToConsole = true;
    }

    render() {
        const {loggedIn} = this.props;
        const user = JSON.parse(localStorage.getItem("user"));
        let nameCapitalized;
        if (user) {
            nameCapitalized =
                user.result.user.user_name
        } else {
            nameCapitalized = null;
        }
        return (
            <div>
                <Nav pullRight>
                    {loggedIn && (
                        <React.Fragment>
                            <div className="dropdown headerLogin">
                                <div
                                    style={{color: "#fff"}}
                                    className="dropdown-toggle"
                                    data-toggle="dropdown"
                                >
                                    <img
                                        src={userIcon}
                                        alt="user icon"
                                        className="headerUserIcon"
                                    />
                                    <span style={{marginLeft: "5px"}}>
                                        {nameCapitalized}
                                    </span>
                                    <span className="caret"></span>
                                </div>
                                <ul
                                    className="dropdown-menu text-center topNav"
                                    style={{backgroundColor: "#1684e4"}}
                                >
                                    <div style={{padding: "5px 5px 10px 0"}}>
                                        <Link to={"/Admin/profile"}>
                                            <img
                                                src={userIcon}
                                                alt="user icon"
                                                className="headerUserIcon"
                                                style={{
                                                    height: "21px",
                                                    marginLeft: "3px"
                                                }}
                                            />
                                            {"  "}
                                            My Profile
                                        </Link>
                                    </div>
                                    <div style={{padding: "5px 0 10px 0"}}>
                                        <Link to={"/Admin/changePassword"}>
                                            <img
                                                src={password}
                                                alt="password icon"
                                                className="headerUserIcon"
                                                style={{
                                                    height: "21px",
                                                    marginLeft: "3px"
                                                }}
                                            />
                                            {"  "}
                                            Change Password
                                        </Link>
                                    </div>
                                    <div style={{padding: "5px 5px 10px 0"}}>
                                        <Link
                                            to={"/Admin-login"}
                                            // onClick={() =>
                                            //     this.props.onLogoutClick()
                                            // }
                                        >
                                            <img
                                                src={logoutIcon}
                                                alt="logoutIcon"
                                            />
                                            {"  "}
                                            Logout
                                        </Link>
                                    </div>
                                </ul>
                            </div>
                        </React.Fragment>
                    )}
                </Nav>
                <div className="t-material-dark pull-right mt-sm mr-md">
                    {
                        this.state.user_role !== 'customer manager' && false &&
                        <NotificationContainer/>
                    }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {userAdmin, loggedIn} = state.adminReducer;
    return {
        userAdmin,
        loggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return dispatch => {
        return {
            onLogoutClick: () => {
                dispatch(adminUserActions.logout());
            },
            messageCall: message => {
                dispatch(alertActions.success(message, "notification"));
            }
        };
    };
}

const HeaderLinks = connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderLinksPage);
export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Admin/Header/HeaderLinks.jsx